import { Link } from '@inertiajs/react'
import { tasks_path } from '@/lib/routes'

export interface CycleTask {
  id: string
  details: string
  pic_names: string[]
  assigned_to_me: boolean
}

// One-line recap of the open "Create Top Down Plan" task connected to a
// draft plan, shown inside the plan-status banner cards. PICs get the task
// as a link to their Tasks page (opens the task's drawer); everyone else
// sees plain text — the task isn't theirs to act on.
export default function ConnectedTaskLine({ task }: { task: CycleTask }) {
  return (
    <div>
      <strong>Connected task:</strong>{' '}
      {task.assigned_to_me ? (
        <Link href={tasks_path({ task: task.id })} className="font-medium text-link hover:underline">
          {task.details}
        </Link>
      ) : (
        task.details
      )}
      {task.assigned_to_me && task.pic_names.length > 0 &&
        ` · PIC${task.pic_names.length > 1 ? 's' : ''}: ${task.pic_names.join(', ')}`}
    </div>
  )
}
